import dayjs from 'dayjs';

export const convertTimestampToDayjs = (
  timestamp: number,
  timezone?: string,
) => {
  return dayjs.unix(timestamp).tz();
};
